// extracted by mini-css-extract-plugin
export var fileUpload = "_i2-1";
export var modalButton = "_i2-0";